import AbstractEditWidget from "cluetrainer/ui/widgets/AbstractEditWidget";
import { observe } from "../../reactive";
import { C } from "../constructors";
var cls = C.cls;
export class Checkbox extends AbstractEditWidget {
    constructor(label = "", type = "checkbox") {
        super(cls("nisl-checkbox"));
        this.label = label;
        this.enabled = observe(true);
        this.type = observe(type);
        this.type.subscribe((value) => {
            this.new_box.toggleClass("nisl-checkbox-radio", value == "radio");
        });
        this.new_box = c("<div class='nisl-checkbox-box'>")
            .on("click", () => {
            if (this.isEnabled())
                this.commit(!this.get(), true);
        })
            .appendTo(this.container);
        cls("nisl-checkbox-checkmark").appendTo(this.new_box);
        this.new_box.toggleClass("nisl-checkbox-radio", this.type.value() == "radio");
        if (this.label) {
            cls("nisl-checkbox-label").append(this.label).appendTo(this);
        }
        this.setValue(false);
        this.enabled.subscribe(v => {
            this.toggleClass("nisl-checkbox-disabled", !v);
        });
    }
    render() {
        this.new_box.toggleClass("checked", this.get());
    }
    setEnabled(v) {
        this.enabled.set(v);
        return this;
    }
    isEnabled() {
        return this.enabled.value();
    }
}
(function (Checkbox) {
    class Group {
        constructor(buttons, can_be_null = false) {
            this.buttons = buttons;
            this.value = observe(null);
            buttons.forEach(o => {
                o.button.type.set("radio");
                o.button.onCommit(v => {
                    if (v)
                        this.value.set(o.value);
                    else if (!v && this.value.value() == o.value) {
                        if (can_be_null)
                            this.value.set(null);
                        else
                            o.button.setValue(true);
                    }
                });
            });
            this.value.subscribe(v => {
                this.buttons.forEach(b => {
                    b.button.setValue(b.value == v);
                });
            });
            if (can_be_null)
                this.value.set(null);
            else
                buttons[0].button.setValue(true);
        }
        get() {
            return this.value.value();
        }
        setValue(v) {
            this.value.set(v);
            return this;
        }
        onChange(f) {
            this.value.subscribe(f);
            return this;
        }
        checkboxes() {
            return this.buttons.map(b => b.button);
        }
    }
    Checkbox.Group = Group;
})(Checkbox || (Checkbox = {}));
